import type { Office } from "@mnk/shared/models/office";
import { useNavigate } from "react-router-dom";

interface Props {
  offices: Office[];
}

export const OfficeCardView = ({ offices }: Props) => {
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {offices.map((office) => (
        <div
          key={office.id}
          className="bg-white rounded-lg p-4 cursor-pointer"
          onClick={() => {
            navigate(`/offices/${office.id}`);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              navigate(`/offices/${office.id}`);
            }
          }}
        >
          <h2 className="text-lg">{office.name}</h2>
        </div>
      ))}
    </div>
  );
};
